<template>
  <div class="wt2-sg wt-storyboard-category-list">
    <div class="-categories-title">
      {{ 'metadataEditor.categories' | culture }}
      <span v-if="error" class="error">
        {{ 'metadataEditor.categoriesError' | culture }}</span
      >
      <div
        v-if="isImpededTemplatizer"
        class="wt2-color-link wt2-text-n -manage-topics"
        id="storyMetadataEditor-openTopicManager"
        @click="$emit('showTopicManager')"
      >
        <span class="wticon wticon-pencil3"></span>
        <span>{{ 'dashboardFilter.manageTopics' | culture }}</span>
      </div>
    </div>
    <div class="-categories">
      <ul v-for="(categoryType, typeIndex) in categoryTypes" :key="typeIndex">
        <div
          v-if="showCategoryTypeTitles"
          class="-category-type-title"
          v-text="typeIndex"
        />
        <li
          v-for="category in categoryType"
          :key="category.id"
          @click="error = false"
          :title="category.categoryName"
        >
          <wt-check-box
            v-model="selectedCategories[category.id]"
            :label-right="category.categoryName"
          />
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import app from 'app';
import Vue from 'vue';
import { mapGetters, mapState } from 'vuex';

export default Vue.extend({
  name: 'StoryboardCategoriesList',

  store() {
    return app.rootStore;
  },

  data() {
    return {
      selectedCategories: {},
      error: false,
    };
  },

  computed: {
    ...mapState(['storyboardCategories', 'channelOwnedCategories']),
    ...mapGetters('user', ['isImpededTemplatizer']),

    categoriesList() {
      return this.isImpededTemplatizer
        ? this.channelOwnedCategories
        : this.storyboardCategories;
    },

    showCategoryTypeTitles() {
      return Object.keys(this.categoryTypes).length > 1;
    },

    categoryTypes() {
      const cats = {};
      _.each(this.categoriesList, (ct) => {
        const categoryType = _.startCase(
          _.toLower(ct.categoryType || 'default')
        );

        if (!cats[categoryType]) {
          cats[categoryType] = [];
        }
        cats[categoryType].push(ct);
      });
      return cats;
    },
  },
});
</script>

<style lang="scss" scoped>
@import 'style_guide/_sg_variables.scss';

.wt-storyboard-category-list {
  .-categories-title {
    display: flex;
    margin: 30px 0 15px 0;
    > .error {
      margin-left: 20px;
      color: $color-error;
    }
  }

  .-categories {
    max-height: 200px;
    overflow: auto;
    padding-left: 0;

    .-category-type-title {
      color: $color-primary;
      margin: 5px 0 15px;
    }

    ul {
      padding: 0;
      clear: both;
    }

    li {
      list-style: none;
      display: block;
      margin-bottom: 15px;
      float: left;
      width: calc(100% / 4 - 15px);
      margin-right: 15px;
    }
  }

  .-manage-topics {
    margin-left: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    .wticon {
      margin-right: 0.5rem;
      font-size: 1.5rem;
    }
  }
}
</style>
